import React, { useContext } from 'react';
import { Button, Card, CardContent, Typography, Grid, Box, Paper } from '@mui/material';
import styles from '../../../../assets/styles/componentStyles/getStartedStyles/getStartedStyles.module.scss';
import globalStyles from "../../../../assets/styles/global.module.scss";
import Whatsapp from '../../../../assets/images/getStarted/Whatsapp.png';
import Chatbot from '../../../../assets/images/getStarted/Chatbot.png';
import RuleBaseChatBot from '../../../../assets/images/getStarted/RuleBaseChatBot.png';
import Arrow from '../../../../assets/images/getStarted/Arrow.png';
import GreenTick from '../../../../assets/images/getStarted/GreenTick.png';
import PurpleTick from '../../../../assets/images/getStarted/PurpleTick.png';
import BlueTick from '../../../../assets/images/getStarted/BlueTick.png';
import { WhatsappCampaignContext, WhatsappCampaignContextPayload } from '../../../../context/whatsappCampaignContext';
import { useNavigate } from 'react-router-dom';
import { getStartedPageFeature } from '../../../../models/axiosModel';
import { WorkflowContext, WorkflowContextPayload } from '../../../../context/workflowContext';

const FeatureCard = () => { 

    const navigate = useNavigate();
    const { setFlagIntegrateBusinessAccountPopup } = useContext(WhatsappCampaignContext) as WhatsappCampaignContextPayload; 
    const { setFlagIntegrateBusinessAccountPopup: setFlagWorkflowIntegrateBusinessAccount } = useContext(WorkflowContext) as WorkflowContextPayload

    const cards = [
        {
            icon: Whatsapp,
            title: 'WhatsApp Campaign',
            description: 'Send bulk personalized messages to engage your audience.',
            features: ['Bulk messaging', 'Retargeting', 'Campaign Analysis'],
            buttonText: 'Create Campaign',
            className: styles.greenCard,
            tickImage: GreenTick, 
            handleBtnClick: () => {
                navigate("/whatsappcampaign/createnewcampaign"); 
                setFlagIntegrateBusinessAccountPopup(true); 
            }
        },
        {
            icon: Chatbot,
            title: 'AI Chatbot',
            description:'Automate conversations with AI on WhatsApp, Facebook, Instagram, and your Website.',
            features: ['Omnichannel', '24/7 AI Assistance', 'Seamless agent transfer'],
            buttonText: 'Create AI Chatbot',
            className: styles.purpleCard,
            tickImage: PurpleTick, 
            handleBtnClick: () => {
                navigate("/chatbot"); 
            }
        },
        {
            icon: RuleBaseChatBot,
            title: 'Rule-Based Chatbot',
            description:'Automate with pre-defined rules for step-by-step user interactions.',
            features: ['Custom workflows', 'Easy setup', 'Predictable responses'],
            buttonText: 'Create Rule-Based Chatbot',
            className: styles.blueCard,
            tickImage: BlueTick, 
            handleBtnClick: () => {
                navigate("/workflow");  
                setFlagWorkflowIntegrateBusinessAccount(true);
            }
        },
    ];

    return ( 
        <Grid container spacing={2} sx={{marginTop:2}}>
            {cards.map((card, index) => {
                return (
                    <Grid item xs={12} sm={12} md={6} lg={4} key={index} className={`${globalStyles.displayFlexStyle} ${globalStyles.justifyCenter}`}>
                        <Paper
                            className={`${styles.getStartedFeatureCardWrapper} ${card.className}`}>
                            <Box className={styles.getStartedFeatureCardBox}>
                                <div className={styles.iconCircle}>
                                    <img src={card.icon} alt={card.title} height={50} width={50} />
                                </div>
                                <Typography variant="h6" className={styles.title}>
                                    {card.title}
                                </Typography>
                                <Typography variant="body2" className={styles.description}>
                                    {card.description}
                                </Typography>
                                <Box className={styles.featureCardFeatures}>
                                    <ul className={styles.featureList}>
                                        {card.features.map((feature, i) => (
                                            <li 
                                                key={i}  
                                                className={styles.featuresListItem}
                                                >
                                                <img 
                                                    src={card.tickImage}
                                                    alt="tick" 
                                                    height={16}
                                                    width={16}
                                                />
                                                <span>{feature}</span>
                                            </li>
                                        ))}
                                        </ul>
                                </Box>
                            </Box>

                            <Button
                                variant="contained"
                                className={styles.button}
                                fullWidth
                                sx={{ mt: 2, display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                                onClick={() => card.handleBtnClick()}
                            >
                                {card.buttonText} 
                                <Box
                                    component="img"
                                    src={Arrow}
                                    alt="arrow"
                                    sx={{ height: 13, width: 13, ml: 1 }} 
                                />
                            </Button>
                        </Paper>
                    </Grid>
                );
            })}
         </Grid>
    );
};


export default FeatureCard;